export const tableFieldOrderOverview = [
  { text: 'langkey.date', align: 'center', value: 'created', sortable: true },
  { text: 'langkey.order-id', align: 'center', value: 'id', sortable: true },
  { text: 'langkey.order-information', align: 'left', value: 'comment', sortable: false, class: 'no-icon' },
  { text: 'langkey.invoice-id', align: 'center', value: 'invoicePdfUrls', sortable: true },
  { text: 'langkey.order-status', align: 'center', value: 'status', sortable: true },
  { text: 'langkey.tracking-link', align: 'center', value: 'trackingNumber', sortable: false, class: 'no-icon' },
];
